import { PageHero } from "../components/PageHero";
import { PortfolioSection } from "../components/sections/PortfolioSection";
import { Testimonials } from "../components/sections/Testimonials";
import { ContactSection } from "../components/sections/ContactSection";

export default function Portfolio() {
  return (
    <div data-testid="portfolio-page">
      <PageHero
        overline="Portfolio"
        title="Projekty"
        emphasis="demonstracyjne."
        subtitle="Przykładowe rozwiązania pokazujące, jak nowoczesna strona, AI i automatyzacja mogą wspierać różne rodzaje firm."
      />
      <PortfolioSection heading={false} />
      <Testimonials />
      <ContactSection />
    </div>
  );
}
